import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
      <g id="H" transform="translate(25.000000, 27.000000)">
        
        <path d="M 22 35 L 22 19.05 L 4.75 19.05 L 4.75 35 L 0 35 L 0 0 L 4.75 0 L 4.75 14.95 L 22 14.95 L 22 0 L 26.75 0 L 26.75 35 L 22 35 Z" fill="currentColor"/>
      </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
